module.exports = __webpack_public_path__ + "img/alipay.5a0a92b6.png";